import { WorkflowStep } from '../../workflow-navigation/reducers/workflow-step';
import { ScreenGuard } from './screen-index';
import { WorkflowScreen } from '../../workflow-navigation/reducers/workflow-screen';
import { ClaimWorkflow } from './claim-workflow';
import { ClaimType } from '../../claim/claim-types';
import { PaymentsView } from '../../payment';
import { WorkflowUtilityScreen } from '../../workflow-navigation/reducers/workflow-utility-screen';
import { WorkflowAssessorScreen } from '../../workflow-navigation/reducers/workflow-assessor';
import { ClaimAuditTrailView } from '../../claim-audit-trail';
import { EarlyRetirementSynopsis } from '../../assessment/synopsis/early-retirement/early-retirement-synopsis';
import { EarlyRetirementAssessmentDetailsView } from '../../assessment/decisions/early-retirement/views/early-retirement-assessment-details';
import { DashboardFlowView } from '../../assesor-dashboard/views/dashboard/assessor-dashboard';
import { AuthGuard } from '../../auth/authGuard';
import { LivingLifestyleSynopsis } from '../../assessment/synopsis/living-lifestyle/living-lifestyle-synopsis';

const assessorDashboardGuard = AuthGuard(['AssessorDashboard']);
const underwritingGuard = AuthGuard(['Underwriting', 'Agent']);

export const earlyRetirementWorkflow = new ClaimWorkflow(
    'Early Retirement',
    [
        new WorkflowStep('Initiate Claim', []),
        new WorkflowStep('Assessment', [
            new WorkflowScreen(
                'Synopsis',
                EarlyRetirementSynopsis,
                undefined,
                undefined,
                ScreenGuard
            ),
            new WorkflowScreen(
                'Decisions',
                EarlyRetirementAssessmentDetailsView,
                undefined,
                undefined,
                ScreenGuard
            ),
        ]),
        new WorkflowStep('Underwriting', [
            new WorkflowScreen(
                'Synopsis ',
                LivingLifestyleSynopsis,
                undefined,
                undefined,
                underwritingGuard
            ),
            new WorkflowScreen(' ', undefined, undefined, undefined, underwritingGuard),
        ]),
        new WorkflowStep('Payments', [
            new WorkflowScreen('Payments', PaymentsView, undefined, undefined, () => false),
        ]),
        new WorkflowAssessorScreen(
            'Assessor List',
            'Assessor limits dashboard',
            DashboardFlowView,
            undefined,
            'Assessor limits dashboard',
            assessorDashboardGuard
        ),
        new WorkflowUtilityScreen(
            'Claim Audit Trail',
            'list',
            ClaimAuditTrailView,
            undefined,
            undefined,
            ScreenGuard
        ),
    ],
    claim => claim.claimType === ClaimType.EarlyRetirement,
    undefined,
    ScreenGuard
);
